import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { AppDownloadButton } from "./AppDownloadButton";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Motion";
import { PhoneMockup } from "./PhoneMockup";
import { GlowOrb } from "./Glow";
import { SCREENS as APP } from "@/config/screens";

const SCREENS = [
  { ...APP.welcome, shift: 50 },
  { ...APP.opportunities, shift: -40 },
  { ...APP.analytics, shift: 60 },
];
const LINES = ["Pitch opportunities.", "Check your analytics.", "Track releases.", "Monitor campaigns.", "Discover what's next."];

const ShowcasePhone = ({ screen, progress, i }) => {
  const y = useTransform(progress, [0, 1], [screen.shift, -screen.shift]);
  return (
    <motion.figure style={{ y }} className={`snap-center ${i === 1 ? "lg:-mt-16" : ""}`}>
      <PhoneMockup scale={1} testId={`showcase-phone-${i + 1}`} src={screen.src} label={screen.label} />
      <figcaption className="mt-5 flex items-baseline gap-3">
        <span className="font-mono text-[11px] text-pa-orange-text">0{i + 1}</span>
        <span className="font-display text-2xl uppercase text-pa-ink">{screen.name}</span>
      </figcaption>
    </motion.figure>
  );
};

export const AppShowcase = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  return (
    <section ref={ref} id="app" data-testid="app-showcase-section" className="relative overflow-hidden border-t border-white/10 py-section-sm lg:py-section">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <SectionHeading className="lg:col-span-7" size="xl" eyebrow="The app / 03" lines={["Your music career.", <span className="text-glow text-pa-orange">In your pocket.</span>]} label="Your music career. In your pocket." />
        <Reveal delay={0.15} className="self-end lg:col-span-5">
          <p className="text-base leading-relaxed text-pa-muted md:text-lg">Your career doesn&apos;t stop when you leave your laptop.</p>
          <ul className="mt-6 border-t border-white/10">
            {LINES.map((l) => <li key={l} className="border-b border-white/10 py-3 font-display text-2xl uppercase tracking-wide text-pa-ink">{l}</li>)}
          </ul>
          <p className="mt-6 text-pa-ink">All from your phone.</p>
          <AppDownloadButton label="Download Pitchally" source="app-showcase" testId="showcase-download-btn" className="mt-8" />
        </Reveal>
      </div>
      <GlowOrb className="left-1/2 top-[55%] h-[640px] w-[900px] -translate-x-1/2" strength="lg" />
      <div className="no-scrollbar relative mt-20 flex snap-x snap-mandatory gap-8 overflow-x-auto px-5 pb-24 pt-24 sm:px-8 lg:mx-auto lg:max-w-[1100px] lg:justify-between lg:overflow-visible lg:px-12">
        {SCREENS.map((s, i) => <ShowcasePhone key={s.name} screen={s} progress={scrollYProgress} i={i} />)}
      </div>
      <p className="px-5 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-pa-dim">Screens from the Pitchally app · analytics shown with demo data</p>
    </section>
  );
};
